/**
 * Dettaglio collezione (pagina per singolo set, es. "Set Samurai").
 * Cambio istantaneo tra i design al click sui numeri: nessuna animazione,
 * solo toggle della classe is-active su pannello e pallino corrispondenti.
 *
 * Effetto tilt 3D: il disco del tombino ruota leggermente "seguendo" la
 * posizione del cursore (solo dispositivi con mouse reale, non touch;
 * disattivato se l'utente preferisce ridurre le animazioni).
 */
(function () {
  'use strict';

  var TILT_MAX_DEG = 14;
  var TILT_SCALE = 1.04;

  var canTilt =
    window.matchMedia &&
    window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
    !(window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function initTilt(circle) {
    if (!canTilt) return;

    circle.addEventListener('mousemove', function (event) {
      var rect = circle.getBoundingClientRect();
      var percentX = (event.clientX - rect.left) / rect.width - 0.5;
      var percentY = (event.clientY - rect.top) / rect.height - 0.5;
      var rotateY = percentX * TILT_MAX_DEG * 2;
      var rotateX = percentY * TILT_MAX_DEG * -2;
      circle.style.transition = 'transform 0.1s ease-out';
      circle.style.transform =
        'rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) scale(' + TILT_SCALE + ')';
    });

    circle.addEventListener('mouseleave', function () {
      circle.style.transition = 'transform 0.5s cubic-bezier(0.22, 1, 0.36, 1)';
      circle.style.transform = '';
    });
  }

  function initHotspots(panel) {
    var pins = panel.querySelectorAll('.roji-dettaglio__pin');
    var items = panel.querySelectorAll('.roji-dettaglio__hotspot-item');
    var callout = panel.querySelector('.roji-dettaglio__callout');
    if (!pins.length && !items.length) return;

    var eyebrowEl = callout ? callout.querySelector('[data-hotspot-eyebrow]') : null;
    var titleEl = callout ? callout.querySelector('[data-hotspot-title]') : null;
    var textEl = callout ? callout.querySelector('[data-hotspot-text]') : null;
    var closeBtn = callout ? callout.querySelector('[data-hotspot-close]') : null;

    function setActive(index) {
      pins.forEach(function (pin) {
        var isActive = pin.dataset.hotspotPin === index;
        pin.classList.toggle('is-active', isActive);
        pin.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });
      items.forEach(function (item) {
        var isActive = item.dataset.hotspotItem === index;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });
    }

    function activate(index) {
      var item = panel.querySelector('.roji-dettaglio__hotspot-item[data-hotspot-item="' + index + '"]');
      if (!item) return;

      var label = item.querySelector('.roji-dettaglio__hotspot-label');
      var textSource = item.querySelector('[data-hotspot-item-text]');

      setActive(index);

      if (callout) {
        if (eyebrowEl) eyebrowEl.textContent = 'Punto ' + (parseInt(index, 10) + 1);
        if (titleEl) titleEl.textContent = label ? label.textContent : '';
        if (textEl) textEl.textContent = textSource ? textSource.textContent : '';
        callout.hidden = false;
      }
    }

    function closeCallout() {
      setActive('');
      if (callout) callout.hidden = true;
    }

    pins.forEach(function (pin) {
      pin.addEventListener('click', function () {
        if (pin.classList.contains('is-active')) {
          closeCallout();
        } else {
          activate(pin.dataset.hotspotPin);
        }
      });
    });

    items.forEach(function (item) {
      function toggle() {
        if (item.classList.contains('is-active')) {
          closeCallout();
        } else {
          activate(item.dataset.hotspotItem);
        }
      }
      item.addEventListener('click', toggle);
      item.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle();
        }
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeCallout);
    }
  }

  function initSection(sectionId) {
    var suffix = '-' + sectionId;
    var nav = document.getElementById('RojiDettaglioNav' + suffix);
    var body = document.getElementById('RojiDettaglioBody' + suffix);
    if (!nav || !body) return;

    var dots = nav.querySelectorAll('.roji-dettaglio__nav-dot');
    var panels = body.querySelectorAll('.roji-dettaglio__panel');

    body.querySelectorAll('.roji-dettaglio__circle').forEach(initTilt);
    panels.forEach(initHotspots);

    nav.addEventListener('click', function (event) {
      var dot = event.target.closest('.roji-dettaglio__nav-dot');
      if (!dot || !nav.contains(dot)) return;

      var index = dot.dataset.designIndex;

      dots.forEach(function (d) {
        var isActive = d === dot;
        d.classList.toggle('is-active', isActive);
        d.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.dataset.designPanel === index);
      });
    });
  }

  function init() {
    var scripts = document.querySelectorAll('script[data-section-id][src*="roji-collezione-dettaglio.js"]');
    scripts.forEach(function (script) {
      initSection(script.getAttribute('data-section-id'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var nav = event.target.querySelector('[id^="RojiDettaglioNav-"]');
    if (nav) {
      var sectionId = nav.id.replace('RojiDettaglioNav-', '');
      initSection(sectionId);
    }
  });
})();
